import './index.scss';
import React, { useState } from 'react';
import GeniusButton from '~/components/genius_button';
import ResponsiveItem from '~/components/responsive_item';
import { useContentLibrary } from '../../../../providers/content_library_provider';
const ParentDocuments = ({ clause }) => {
    const { clauseParentMetadata } = useContentLibrary();
    const [showAdditionalParentDocuments, setShowAdditionalParentDocuments] = useState(false);
    const buildParentDocumentList = () => {
        const hasAllParents = clause.source.parentDocuments.every(parentDoc => clauseParentMetadata.findIndex(pm => pm.file.id === parentDoc.id) !== -1);
        if (hasAllParents) {
            return clause.source.parentDocuments.map(parentDoc => {
                const fileMetadata = clauseParentMetadata.find(cpm => cpm.file.id === parentDoc.id);
                if (!fileMetadata)
                    return React.createElement(React.Fragment, null);
                const formNumber = fileMetadata.metadataFields.find(mf => mf.name === 'Form Number');
                if (!formNumber)
                    return React.createElement(React.Fragment, null);
                let documentName = `${formNumber.value}`;
                const formEditionDate = fileMetadata.metadataFields.find(mf => mf.name === 'Form Edition Date');
                if (formEditionDate) {
                    documentName += ` ${formEditionDate.value}`;
                }
                let formTitle = fileMetadata.metadataFields.find(mf => mf.name === 'Form Title');
                if (!formTitle)
                    formTitle = fileMetadata.metadataFields.find(m => m.name === 'Form Name');
                return (React.createElement(React.Fragment, { key: `parent-document-header-info-${parentDoc.id}` },
                    formTitle && React.createElement(ResponsiveItem, { overflowText: `${formTitle.value}`, fontSize: '14px' },
                        React.createElement("div", { className: 'result-form-name' }, formTitle.value)),
                    React.createElement(ResponsiveItem, { overflowText: documentName, fontSize: '14px' },
                        React.createElement("div", { className: 'result-document-name overflow-ellipsis' }, documentName))));
            });
        }
        else {
            return React.createElement("div", { style: { fontSize: '14px' } }, "Loading...");
        }
    };
    let documentName = clause.source.formNumber;
    if (clause.source.formEditionDate) {
        documentName += ` ${clause.source.formEditionDate}`;
    }
    return (React.createElement("div", { className: 'result-parent-documents' },
        React.createElement(ResponsiveItem, { overflowText: clause.source.formTitle || '', fontSize: '14px' },
            React.createElement("div", { className: 'result-form-name' }, clause.source.formTitle || clause.source.formName)),
        React.createElement("div", { className: 'result-form-number', style: { display: 'flex' } },
            React.createElement(ResponsiveItem, { overflowText: documentName, fontSize: '14px' },
                React.createElement("div", { className: 'result-document-name overflow-ellipsis' }, documentName)),
            clause.source.parentDocuments.length > 1 &&
                React.createElement(GeniusButton, { className: 'parent-document-toggle-button', icon: `fa-lg fal ${showAdditionalParentDocuments ? 'fa-angle-up' : 'fa-angle-down'}`, onClick: () => setShowAdditionalParentDocuments(!showAdditionalParentDocuments), text: clause.source.parentDocuments.length.toString() })),
        showAdditionalParentDocuments && buildParentDocumentList()));
};
export default ParentDocuments;
